// Centralized API base URL configuration.
// Prefer environment variable to allow per-environment overrides.
export const API_BASE_URL =
  import.meta.env.VITE_API_BASE_URL || "https://localhost:7026";
